import React from 'react';

import {
    Paper,
    Box,
    Grid,
    ListItem,
    Typography
} from '@material-ui/core';
import { Link } from "react-router-dom";
import { useTranslate } from 'react-admin';
import colors from '../CustomizedUIs/Colors'
import {
    makeStyles, useTheme
} from '@material-ui/core/styles';
import ArrowRightButton from '../CustomizedUIs/ArrowRightButton';
const useStyles = makeStyles(theme => ({

    searchPaper: {
        padding: '5px 10px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
        width: '236px',
        boxShadow: 'none'
    },
    TitleCluster: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    Paper: {
        borderRadius: '10px',
        boxShadow: ' 0 3px 6px 0 rgba(27, 102, 157, 0.04)',
        backgroundColor: '#ffffff',
    },
    TextCluster: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
    },
    borderCluster: {
        borderRadius: '10px',
        border: 'solid 1px #e0f0f2',
        backgroundColor: '#fafefe',
        padding: '11px'
    },
    borderArrow: {
        borderRadius: '10px',
        backgroundColor: ' #e5f1f8',
    }

}))


const GridItem = ({ data }) => {
    const translate = useTranslate()
    const classes = useStyles();
    const theme=useTheme()

    return (
        <Grid xs={12} lg={4} item>
            <Paper className={classes.Paper}>
                <ListItem
                    button
                    component={Link}
                    to={{
                        pathname: "/Entity/" +  encodeURIComponent(data.name)
                    }}>
                    <Box px={1} width='100%'>
                        <Box py={2}><Typography className={classes.TitleCluster}>{data.name}</Typography></Box>
                        <Box display='flex' direction="row" justify="flex-start" alignItems="center">
                            <Box display='flex' py={2} flexGrow={1}>
                                <Box width={80}
                                    display='flex'
                                    justifyContent='center'
                                    p={1}
                                    mr={1}
                                    className={classes.borderCluster}
                                >
                                    <Typography className={classes.TextCluster}>
                                        {(data.groupCount + " " + translate(data.groupCount <= 1 ? `pos.dashboard.group` : `pos.dashboard.groups`)).toUpperCase()}
                                    </Typography>
                                </Box>
                                <Box width={80}
                                    display='flex'
                                    justifyContent='center'
                                    borderRadius='10px'
                                    className={classes.borderCluster}
                                    p={1}
                                >
                                    <Typography className={classes.TextCluster}>
                                        {(data.clusters + " " + translate(data.clusters <= 1 ? `pos.dashboard.cluster` : `pos.dashboard.clusters`)).toUpperCase()}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <ArrowRightButton color={theme.squareButon.content}/>
                            </Box>
                        </Box>
                    </Box>
                </ListItem>
            </Paper>
        </Grid >
    );
}

const GridContainer = ({ data, filter }) => {
    return (
        <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            spacing={3}
        >
            {data.entities
                .filter(
                    (value) =>
                        value.name
                            .replace(/ /g, "")
                            .toUpperCase()
                            .indexOf(filter.replace(/ /g, "").toUpperCase()) > -1
                )
                .map((row, index) => (
                    <GridItem key={index} data={row} />
                ))}
        </Grid>
    );

}

export default GridContainer
